import { OperationAccess } from 'constants/operationAccesses';

import Skeleton from '@mui/material/Skeleton';
import { usePermissions } from 'hooks/usePermissions';
import { useMerchantCredentialsJson } from 'pages/Merchants/MerchantsShow/MerchantsShowCredentials/hooks/useMerchantCredentialsJson';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Labeled } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { getId } from 'utils/getId';

import { JsonCopyToClipboardFieldStyled } from './MerchantShowAccountsMerchantCredentialsField.styled';

export const MerchantShowAccountsMerchantCredentialsField = (): JSX.Element => {
  const translate = useTypedTranslate();
  const { hasOperationAccess } = usePermissions();

  const merchantCredentialsId = useWatch({ name: 'merchantCredentials' });
  const { credentials, isLoading } = useMerchantCredentialsJson(
    getId(merchantCredentialsId),
    hasOperationAccess(OperationAccess.ManageMerchantCredentials),
  );

  return (
    <Labeled label={translate('app.merchantAccounts.merchantAccessCredentialsWithParams')}>
      {isLoading ? (
        <Skeleton height={160} sx={{ marginBottom: '12px' }} variant="rounded" width="100%" />
      ) : (
        <JsonCopyToClipboardFieldStyled src={merchantCredentialsId ? credentials : {}} />
      )}
    </Labeled>
  );
};
